import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import * as actions from '../actions/project';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import ButtonDeleteChart from './buttonDeleteChart'
import Slide from '@material-ui/core/Slide';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    form: {
        '& > *': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    chart: {
      height: '600px',
      'background-image': 'url(/images/BlueNonCustemer.png)',
      'background-repeat': 'no-repeat',
    },
    gridcolumn: {
      'margin-top': '250px',
      'margin-left': '125px',
    },
    grid: {
    },
    Button: {
      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7)',
      marginRight: '10px'
    },
    buttonDelete: {
      marginLeft: '20px'
    }
}));


function ChangeChartTitle({selected,projectId,chartId,updateChart,title}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = React.useState({
      title: '',
  });

  const handleChange = name => event => {
      setValues({...values, [name]: event.target.value});
  };


  const handleClickUpdate = event => {
    updateChart(projectId, chartId, {...selected, title: values.title})
    setOpen(false)
  };

  const closeModal = () => {
    setOpen(false)
    setValues({
        title: '',
    })
  }

  return (

      <>
        <div
            onClick={() => setOpen(true)}
            style={{cursor: 'pointer', paddingTop: '10px', paddingBottom: '10px'}}>
            {title}
        </div>

        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => closeModal()}
        >
        <Slide direction="up" in={open} mountOnEnter unmountOnExit>
        <div className={classes.paper}>
          <h3>Change chart title</h3>
              <form
                  className={classes.form}
                  noValidate autoComplete="off">
                  <TextField
                      id="title"
                      multiline
                      defaultValue={selected.title}
                      onChange={handleChange('title')}/>
              </form>
              <br/>
              <Button
                  className={classes.Button}
                  variant="contained"
                  color="primary"
                  onClick={() => handleClickUpdate()}>
                  Update
              </Button>
              <ButtonDeleteChart
                projectId={projectId}
                chartId={chartId}
                className={classes.buttonDelete}/>
            </div>
            </Slide>
          </Modal>
      </>
  )
}

const mapStateToProps = state => state.charts;
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(ChangeChartTitle)
